var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8434 19.2368C18.8434 20.3947 17.8961 21.3421 16.7382 21.3421C15.5803 21.3421 14.6329 20.3947 14.6329 19.2368M18.8434 19.2368C18.8434 18.0789 17.8961 17.1316 16.7382 17.1316C15.5803 17.1316 14.6329 18.0789 14.6329 19.2368M18.8434 19.2368H22.0013M14.6329 19.2368H13.5803M13.5803 19.2368H8.31713M13.5803 19.2368V7.86842C13.5803 6.68947 13.5803 6.1 13.3487 5.64737C13.1487 5.25789 12.8329 4.93158 12.4329 4.73158C11.9803 4.5 11.3908 4.5 10.2119 4.5H5.36976C4.19082 4.5 3.60134 4.5 3.14871 4.73158C2.75924 4.93158 2.43292 5.24737 2.23292 5.64737C2.00134 6.1 2.00134 6.68947 2.00134 7.86842M13.5803 19.2368V8.71053H17.7908L20.9487 12.9211M8.31713 19.2368C8.31713 20.3947 7.36976 21.3421 6.21187 21.3421C5.05397 21.3421 4.10661 20.3947 4.10661 19.2368M8.31713 19.2368C8.31713 18.0789 7.36976 17.1316 6.21187 17.1316C5.05397 17.1316 4.10661 18.0789 4.10661 19.2368M4.10661 19.2368C2.94871 19.2368 2.00134 18.2895 2.00134 17.1316V14.5M20.9487 12.9211V19.2368M20.9487 12.9211H13.5803",
  stroke: "#61605D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0013 11.5H4.00134",
  stroke: "#61605D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.00134 11.5L7.00134 14.5",
  stroke: "#61605D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.00134 11.5L7.00134 8.5",
  stroke: "#61605D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgPickupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupIcon);
export default __webpack_public_path__ + "static/media/PickupIcon.17799415.svg";
export { ForwardRef as ReactComponent };